module.exports = __webpack_public_path__ + "07f8b39c0bc9d6ed6284350163dae352.MP3";